import { Component } from 'react';

export class Page extends Component {}

export default Page;
